import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Table } from 'semantic-ui-react';
import cs from 'classnames';
import styles from './table.module.scss';

const TableHeader = (props) => {
  const { t } = useTranslation();
  const {
    columns,
    column,
    direction,
    handleSort,
    isLoading,
    getSortArrow,
  } = props;

  return (
    <Table.Header className={styles.tblHeader}>
      <Table.Row>
        {columns.map((item, index) => {
          const { property, sortable, title, width, headerCustomCell, alignment = null } = item;
          let cellContent = '';

          if (headerCustomCell) {
            cellContent = headerCustomCell(item);
          } else {
            cellContent = (
              <>
                <p>{t(title)}</p>
                {getSortArrow(direction, column, property)}
              </>
            );
          }

          const headerClasses = [];

          if (alignment === 'right-desktop-only') {
            headerClasses.push(styles.rightAlignedHeaderDesktop);
          }

          if (sortable) {
            headerClasses.push(styles.sortable);
          } else {
            headerClasses.push(styles.nonsortable);
          }

          return (
            <Table.HeaderCell
              key={`${property || 'customCell'}_${title || index}`}
              width={width}
              sorted={column === property ? `${direction}ending` : null}
              className={cs(headerClasses)}
              onClick={
                sortable && !isLoading ? () => handleSort(property) : () => {}
              }
            >
              {cellContent}
            </Table.HeaderCell>
          );
        })}
      </Table.Row>
    </Table.Header>
  );
};

TableHeader.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  column: PropTypes.string,
  direction: PropTypes.string,
  handleSort: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  getSortArrow: PropTypes.func.isRequired,
};

TableHeader.defaultProps = {
  column: null,
  direction: null,
};

export default TableHeader;
